import React from "react";
import ProjectDashboard from "containers/Project/Dashboard";
import ProjectListView from "containers/Project/List";


const ProjectMainView = () => {
	const PROJECT_LIST_ID = "projectsTable";

	return (
		<div id="view-main-project">
			<ProjectDashboard  dashboardTilesAriaControls={PROJECT_LIST_ID}/>
			<ProjectListView  projectListId={PROJECT_LIST_ID}/>
		</div>
	);
};

export default ProjectMainView;